var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDividerSupporters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 123,
    viewBox: "0 0 1280 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364.367 31.5033C206.675 -14.6602 81.6535 61.2696 0.312378 123H1280.31V3.29684C1210.45 -6.54421 1069.83 16.1856 952.061 39.8041C804.848 69.3273 522.059 77.6668 364.367 31.5033Z",
    fill: "#916BBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.431 65.7895C154.529 65.7895 100.011 27.9851 -0.312256 54.6834V123L1280.31 123C1258.77 107.439 917.625 0.460375 841.939 39.804C766.253 79.1476 630.233 77.7363 553.973 54.6834C482.196 32.9856 404.333 65.7895 279.431 65.7895Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerSupporters);
export default __webpack_public_path__ + "static/media/divider_supporters.c7ed78772c1205fcc9406811459af2d5.svg";
export { ForwardRef as ReactComponent };